import Vue from 'vue'
//css per leafleft
import 'leaflet/dist/leaflet.css';

//Vue loading
import Loading from 'vue-loading-overlay'; //versione 3.0 https://github.com/ankurk91/vue-loading-overlay/tree/v3.x
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.component('loading', Loading)

// import VUE components
import Example from './components/example.vue';
import Catalogo from './components/Catalogo.vue';
import CatalogoTicket from './components/CatalogoTicket.vue'
import CalendarioVariazione from './components/CalendarioVariazione.vue';


//tutto eseguito 

(function($){
    window.$ = $;

    require('bootstrap');
    require('bootstrap-select/js/bootstrap-select');
    $.fn.selectpicker.Constructor.BootstrapVersion = "4.6.0";
    require("./scss/main.scss");
    //require('owl.carousel');
    //require('bootstrap-italia/src/js/plugins/fonts-loader');
    //require('bootstrap-italia/src/js/plugins/select');
    //require('bootstrap-italia/src/js/plugins/forms');
    //require('bootstrap-italia/src/js/plugins/datepicker/locales/it');
    //require('bootstrap-italia/src/js/plugins/datepicker/datepicker');
    //require('bootstrap-italia/src/js/plugins/carousel');

    // Facendo l'ovveride della funzione val di jquery possiamo lanciare la reazione di vue alla modifica dei componenti jquery
    var originalVal = $.fn.val;

    $.fn.val = function (value) {
        if (arguments.length >= 1) {
            if (value !== undefined && value != this[0].value) {
                var data = originalVal.apply(this, arguments);
                this[0].dispatchEvent(new Event('input'))
                this[0].dispatchEvent(new Event('change'))
                this[0].dispatchEvent(new Event('changed'))
                return data;
            }
        }
        return originalVal.apply(this, arguments);
    };

    const _ = require("lodash")
    window.lodash = _.noConflict();

    Vue.config.productionTip = false

    Vue.prototype.$buildGlobalHeaderAxios = function () {
        return {
            'Content-Type': 'application/json; charset=UTF-8'
        }
    };

    Vue.prototype.$jQueryWrapSelect = function () {

        let onSelectChange = function () {
            $(".dropdown-menu li.selected")
                .find('input[type="checkbox"]')
                .prop("checked", true);
            $(".dropdown-menu li:not(.selected)")
                .find('input[type="checkbox"]')
                .prop("checked", false);
        };

        // Allows to rewrite options dynamically with an object in the form of
        $.fn.setOptionsToSelect = function (optionsData) {
            var selectElement = $(this).find("select");

            // Destroying selectElement
            $(selectElement)
                .off("changed.bs.select")
                .selectpicker("destroy")
                .empty();

            // Appending options according to the optionsData object
            optionsData.forEach(function (x) {
                $(selectElement).append(
                    $("<option>", {
                        value: x.value,
                        text: x.text,
                    })
                );
            });

            // Refreshing selectElement
            $(selectElement)
                .selectpicker("refresh")
                .on("changed.bs.select", onSelectChange);

            return this;
        };

        // Bootstrap-select initialisation
        $(".bootstrap-select-wrapper select")
            .selectpicker()
            .on("changed.bs.select", onSelectChange);

        // Fixes for W3C and WCAG 2.0 compliance:
        var $selectWrapper = $(".bootstrap-select-wrapper");

        // Enter generic and non-visible text for empty options
        $selectWrapper
            .find("select option.bs-title-option")
            .text("Nessuna opzione");
        $selectWrapper.find("select option[data-content]").text("Annulla");

        // Remove the role="combobox" from the dropdown button
        $selectWrapper.find("button.dropdown-toggle").removeAttr("role");

        // Replace any <div>s elements with <span>s as <div>s are not allowed in a button element
        $selectWrapper.find("div.filter-option").replaceWith(function () {
            return $("<span />")
                .addClass("filter-option")
                .append($(this).contents());
        });
        $selectWrapper.find("div.filter-option-inner").replaceWith(function () {
            return $("<span />")
                .addClass("filter-option-inner")
                .append($(this).contents());
        });
        $selectWrapper
            .find("div.filter-option-inner-inner")
            .replaceWith(function () {
                return $("<span />")
                    .addClass("filter-option-inner-inner")
                    .append($(this).contents());
            });

        // Add title and WAI-ARIA attribute for the input search
        $selectWrapper
            .find(".bs-searchbox input")
            .attr("title", "Cerca")
            .attr("aria-expanded", "false");


    };

    let render_component = function (component, id, data) {

        new Vue({
            render: h => h(component, { props: data || {} })
        }).$mount(id);
    }

    ///// VUE DEFAULT SHORTCODES START

    ///// ##0 EXAMPLE
    window.render_example = function (id, dataValue) {
        return render_component(Example, id, dataValue);
    }

    ///// ##1 Catalogo
    window.render_catalogo = function (id, dataValue) {
        return render_component(Catalogo, id, dataValue);
    }

    ///// ##1bis Catalogo servizi
    window.render_servizi = function (id, dataValue) {
        return render_component(CatalogoTicket, id, dataValue);
    }

    ///// ##2 CalendarioVariazione
    window.render_calendario_variazione = function (id, dataValue) {
        return render_component(CalendarioVariazione, id, dataValue);
    }    

    ///// VUE DEFAULT SHORTCODES END

    //// FUNCTION

    ///// START EXPANDIBLE MENU
    window.menu_resize = function () {

        try{
            $('#main-menu nav>ul').data('smartmenus').opts.hideFunction=function(t,e){t.fadeOut(0,e)};
            //console.log("Modica Menu Fade Attiva");
        }catch(error){
            //console.log("Modica Menu Fade Non Attiva");
        }         
        // Select the node that will be observed for mutations
        var submenu=document.querySelectorAll('.megamenu #main-menu nav.elementor-nav-menu--layout-horizontal ul.sub-menu');
        
        var maxHeight=0;
        submenu.forEach(element => {
            if ($(element).height()>maxHeight){
                maxHeight=$(element).height();
            }
        });
        var $header=$("div[data-elementor-type='header']");
        var $sections=$header.find('section');
        $sections.height('auto');
        console.log("MaxHeight: "+maxHeight);
        // Options for the observer (which mutations to observe)
        const config = {   attributeFilter: [ "style" ], attributeOldValue: true, attributes: true, childList: true, subtree: true };

        var targetsNode = [];
        var observers = [];

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList, observer) {
            //var $header=$("div[data-elementor-type='header']");
            var hT=$header.offset().top;
                      
            var hH=$header.height();
            for (const mutation of mutationsList) {
             
                var attributes=mutation.target.getAttributeNode("style").value;

                var regex = /([\w-]*)\s*:\s*([^;]*)/g;

                var match, properties={};
                while(match=regex.exec(attributes)) properties[match[1]] = match[2].trim();

                var match, oldproperties={};
                while(match=regex.exec(mutation.oldValue)) oldproperties[match[1]] = match[2].trim();

                if (oldproperties.display!=properties.display){
                    
                    try{
                        $('#main-menu nav>ul').data('smartmenus').opts.hideFunction=function(t,e){t.fadeOut(0,e)};
                        //console.log("Modica Fade Attiva");
                    }catch(error){
                        //console.log("Modica Fade non attiva");
                    }

                    var $submenu=$(mutation.target);
                    //var $sections=$header.find('section');
                    
                    
                    if (properties.display=='block')
                    {
                        var scrollH=$(window).scrollTop();
                        var sH=maxHeight;
                        var sT=$submenu.offset().top;
                        var offset=30;
                        var newheigth=sH+sT-hT-scrollH+offset;

                        $header.height(hH);
                        console.log("Cambio altezza maxH:"+sH+ " sT"+sT+ " hT"+sT+ " scroolH"+scrollH);
                        $sections.height(newheigth);   

                        try{
                            $('#main-menu nav>ul').data('smartmenus').opts.hideFunction=function(t,e){t.fadeOut(0,e)};
                            //console.log("Modica Menu Fade Attiva");
                        }catch(error){
                            //console.log("Modica Menu Fade Non Attiva");
                        }                          
                    }
                    else{
                        var oneVisibile=false;
                        submenu.forEach(element => {
                            if ($(element).is(":visible")){
                                oneVisibile=true;
                            }
                        });
                            if (oneVisibile==false){
                                //$header.height(hH);
                                $sections.height('auto');
                            }
                    }
                    
                }

            }
        };

        // OBSERVE SU TUTTI I SUBMENU
        submenu.forEach(function(element, index){
            
            targetsNode[index] = element;

            // Create an observer instance linked to the callback function
            observers[index] = new MutationObserver(callback);
            // Start observing the target node for configured mutations
            observers[index].observe(targetsNode[index], config);            

        });

        
        var $hamburger=$("#hamburger-icon");

        $hamburger.click(function() {
            console.log("HIDE");
            $hamburger.hide();
        });

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                    // element added to DOM
                    var hasClass = [].some.call(mutation.addedNodes, function(el) {
                        return el.classList.contains('menu-mobile')
                    });
                    if (hasClass) {
                        observer.disconnect();
                        window.menu_mobile();
                    }
                }
            });
        });
        
        var config2 = {
            attributes: true,
            childList: true,
            characterData: true
        };        
        observer.observe(document.body, config2);

        if(window.location.hash) {
            var $anchorTag = $(window.location.hash);
            var hH=$header.height();
            var aH=$anchorTag.offset().top;
            var scroll=aH-hH;
            $('html,body').animate({scrollTop: scroll},'slow');
            $sections.height('auto');
            console.log("AAAACIAOOOOOO");
            console.log("Scroll to: "+(scroll));
        }      

        var currentUrl=window.location.href.replace(window.location.hash,'');
        console.log(currentUrl);
        $('a[href*="'+currentUrl+'#"]').click(function() {
            $sections.height('auto');
            console.log("CIAOOOOOO");
            submenu.forEach(element => {
                $(element).attr("style", "display: none !important");
            });            
          });

    }    
    ///// END EXPANDIBLE MENU

    ///// START MENU MOBILE
    window.menu_mobile =function(){
        var $hamburger=$("#hamburger-icon");
        var $close=$(".menu-mobile .eicon-close");
        $close.click(function() {
            console.log('SHOW');
            $hamburger.show();
        });        
    }
    ///// END MENU MOBILE    

    //// START GALLERY LIGHTBOX
    var observer = new MutationObserver(function(mutations) {
        $.each(mutations,(i,val)=>{
            let $elem=$(val.target);
            if ($elem.hasClass('elementor-slideshow__description')){
                let $oldText=$elem.html().replaceAll('&gt;','>').replaceAll('&lt;','<');
                console.log($oldText);
                if (val.removedNodes.length==0){
                    $elem.html($oldText);
                }
            }
        })
    });
    
    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
    
    //// END GALLERY LIGHTBOX

    console.log('Hello World!!!')

})(window.jQuery);  